import Cookies from "js-cookie";

window.Cookies = Cookies;

const isDev = import.meta.env.VITE_APP_ENV === "dev";

console.log(isDev);
//  因为本地可能启动多个若依项目,而cookie不提供端口隔离,所以不同项目本地运行需要使用不同的cookie名称来隔离
const TokenKey = isDev ? "Admin-Token-LIMS" : "Admin-Token";

const ExpiresInKey = "Admin-Expires-In";

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token);
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}

export function getExpiresIn() {
  return Cookies.get(ExpiresInKey) || -1;
}

export function setExpiresIn(time) {
  return Cookies.set(ExpiresInKey, time);
}

export function removeExpiresIn() {
  return Cookies.remove(ExpiresInKey);
}
